export default "__VITE_ASSET__Cb8T5RFc__"